import React, { useEffect, useMemo, useState } from 'react';
import './IvMeasurementInfo.css';
import '../../App.css';
import { useSelector } from 'react-redux';
import useIsMobile from '../../hooks/useIsMobile';
import { findSeqIndex } from '../../utils/seqDataUtils';




const IvMeasurementInfo = ({ SelInverter }) => {
  const isMobile = useIsMobile();
  const Iv_list = useSelector((state) => state.Iv_list || {});
  const ivData = useSelector((state) => state.ivData || {});


  const [index, Setindex] = useState(null); // index를 초기값 null로 설정
  const [genTime, setGenTime] = useState(0); // 초기값 0으로 설정
  const dataIndex = useMemo(() => findSeqIndex(ivData, SelInverter), [ivData, SelInverter]);

  // 인버터 선택 시 index 설정
  useEffect(() => {
    if (Iv_list.seq && Array.isArray(Iv_list.seq)) {
      const foundIndex = Iv_list.seq.findIndex(seq => seq === SelInverter);
      if (foundIndex !== -1) {
        Setindex(foundIndex);
      }
    }
  }, [Iv_list, SelInverter]);

  // index와 Iv_list, ivData가 준비되었을 때 genTime 계산
  useEffect(() => {
    if (index !== null && dataIndex !== -1 && ivData.Add_power && Iv_list.iv_capa && ivData.Add_power[dataIndex] && Iv_list.iv_capa[index]) {
      const calculatedGenTime = (ivData.Add_power[dataIndex] / 1000) / Iv_list.iv_capa[index];
      setGenTime(Number(calculatedGenTime.toFixed(1))); // 소수점 1자리로 설정
    }
  }, [dataIndex, index, Iv_list, ivData]);

  return (
    <div>
      <div style={{ margin: '10px', maxWidth: '800px' }}>
        <div className='inverterGenInfo-TopBox'>
          <div style={{ color: '#6B7476', fontSize: isMobile? '17px':'20px', fontWeight: '600', paddingLeft: '20px' }}>◎ 계측정보 </div>
          <div style={{ flexGrow: '1' }}></div>
          <div style={{ color: '#6B7476', fontSize: isMobile? '17px':'20px', fontWeight: '600', paddingRight: '20px' }}>⦁ ⦁ ⦁</div>
        </div>
        <div className='inverterGenInfo-BottomBox'>
          <div className="container">
            <table className="data-table" style={{ marginBottom: '10px' }}>
              <thead>
                <tr style={{backgroundColor:'#B1BCC9', color:'white', fontSize: isMobile? '13px':'20px'}}>
                  <th style={{borderTopLeftRadius:'5px'}}>역률(%)</th>
                  <th>주파수(Hz)</th>
                  <th>내부온도(℃)</th>
                  <th style={{borderTopRightRadius:'5px'}}>누적발전시간(h)</th>
                  <th style={{borderTopRightRadius:'5px'}}>출력제어설정값</th>
                </tr>
              </thead>
              <tbody>
                <tr style={{fontSize: isMobile? '13px':'20px'}}>
                  <td style={{borderBottomLeftRadius:'5px'}}>{((ivData.Grid_Factor?.[dataIndex] ?? 0) / 10).toFixed(1)}</td>
                  <td>{((ivData.Grid_Frq?.[dataIndex] ?? 0) / 10).toFixed(1)}</td>
                  <td>{ivData.temperature?.[dataIndex] ? (ivData.temperature[dataIndex] / 10).toFixed(1) : "정보없음"}</td>
                  <td style={{borderBottomRightRadius:'5px'}}>{genTime}</td>
                  <td style={{borderBottomRightRadius:'5px'}}>정보없음</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IvMeasurementInfo;
